module.exports = __webpack_public_path__ + "media/Images/icon-lock-violet-o-65ee578fa40097be2b263ef7dae8ec74.svg";